export const Routes = {
  root: '/',
  diffs: '/diffs/:date',
  ticker: '/tickers/:ticker',
};
